export * from "./NarrativeText"
